import closeicon from "../../../assets/images/close.svg";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import BackdropModal from "../../common/modal/backdropModal";

const DomesticHelperModal = ({ show, onClose }) => {
  const translate = useLanguageTranslate();

  if (!show) return null;

  return (
    <BackdropModal show={show} onClose={onClose} hideClosebtn>
      <>
        {/* Header */}
        <div className="flex justify-between items-center mb-4 -mt-6">
          <h2 className="text-[#1A2024] text-2xl font-semibold">
            {translate("Domestic Helper Cover", "تغطية العامل المنزلي")}
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full bg-[#E5E9EB]"
          >
            <img src={closeicon} alt="Close" className="w-6 h-6" />
          </button>
        </div>
        <div className="w-full max-w-[500px] max-h-[80vh] h-[370px] max767:h-auto max767:max-h-auto relative">
          <div className="space-y-4">
            <div>
              <h3 className="text-[#1A2024] text-lg font-medium mb-2">
                {translate("Accidents:", "الحوادث:")}
              </h3>
              <p className="text-[#000] text-sm leading-relaxed mb-2">
                {translate(
                  "Sustains accidental bodily injury",
                  "التعرض لإصابة جسدية عرضية"
                )}
              </p>
              <ul className="list-disc list-inside text-[#000] text-sm space-y-1 ml-4">
                <li>
                  {translate(
                    "Which independently of any other cause results in death or permanent disablement.",
                    "والتي تؤدي بشكل مستقل عن أي سبب آخر إلى الوفاة أو العجز الدائم."
                  )}
                </li>
                <li>
                  {translate(
                    "Which necessitates repatriation to his /her home country in the event of his/her death or permanent total disablement.",
                    "مما يستلزم إعادته إلى وطنه في حالة وفاته أو إصابته بعجز كلي دائم."
                  )}
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-[#1A2024] text-lg font-medium mb-2">
                {translate("Contents of Your Home:", "محتويات منزلك :")}
              </h3>
              <p className="text-[#000] text-sm leading-relaxed">
                {translate(
                  "Household goods and personal effects (including Personal Money subject to a limit shown) belonging to you (or for which you are legally responsible) or to resident domestic helpers whilst within your Home, including fixtures and fittings belonging to you (or for which you are responsible)",
                  "الأمتعة المنزلية والأمتعة الشخصية (بما في ذلك الأموال الشخصية الخاضعة للحد الموضح) التي تخصك (أو التي تكون مسؤولاً عنها قانوناً) أو للعمال المقيمين أثناء وجودهم داخل منزلك، بما في ذلك التجهيزات والتركيبات التي تخصك (أو التي تكون مسؤولاً عنها)"
                )}
              </p>
            </div>

            <div className="pt-4">
              <p className="text-[#5B6871] text-xs">
                {translate(
                  "This protection ensures medical care and emergency assistance if accidents occur during these recreational activities.",
                  "تضمن هذه الحماية الرعاية الطبية والمساعدة الطارئة في حالة وقوع حوادث أثناء هذه الأنشطة الترفيهية."
                )}
              </p>
            </div>
          </div>
        </div>
      </>
    </BackdropModal>
  );
};

export default DomesticHelperModal;
